import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DevolucaoEditPage } from '@/features/devolucao/page/edit/DevolucaoEditPage';

const RouteDevolucaoParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.literal('editar'),
        idpk: z.string(),
    }),
]);

export type RouteDevolucaoParams = z.infer<typeof RouteDevolucaoParamsSchema>;

export const Route = createFileRoute('/a/devolucao/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteDevolucaoParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <DevolucaoEditPage {...params} />;
}
